/**
 * Tab body: "By locale" — per-Amazon-storefront platform-wide
 * breakdown. Sourced from sn_domain_aggregates which is synced from
 * Shopnomix's /v1/reporting/domain every 6h. Mirrors the per-pub
 * "By region" tab pubs see in their dashboard, rolled across every
 * active publisher.
 */
export default function LocalesTab({ locales }) {
  if (!locales) return <div className="text-sm text-slate-400">Loading…</div>;
  return (
    <>
      <div className="mb-4 grid grid-cols-3 gap-3">
        <div className="border border-slate-200 rounded-md p-4 bg-white">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Total clicks</div>
          <div className="text-2xl font-mono font-bold mt-1">{(locales.total_clicks || 0).toLocaleString()}</div>
          <div className="text-[10px] text-slate-400 mt-0.5">{locales.start_date} → {locales.end_date}</div>
        </div>
        <div className="border border-slate-200 rounded-md p-4 bg-white">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Total revenue (feed-reported)</div>
          <div className="text-2xl font-mono font-bold mt-1">${Number(locales.total_revenue || 0).toFixed(2)}</div>
        </div>
        <div className="border border-slate-200 rounded-md p-4 bg-white">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Locales active</div>
          <div className="text-2xl font-mono font-bold mt-1">{(locales.domains || []).length}</div>
        </div>
      </div>

      <div className="border border-slate-200 rounded-md overflow-hidden bg-white">
        <table className="w-full text-sm" data-testid="admin-locales-table">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-2.5 text-left font-semibold text-xs uppercase tracking-wider text-slate-600">Storefront</th>
              <th className="px-4 py-2.5 text-right font-semibold text-xs uppercase tracking-wider text-slate-600">Clicks</th>
              <th className="px-4 py-2.5 text-right font-semibold text-xs uppercase tracking-wider text-slate-600">Revenue</th>
              <th className="px-4 py-2.5 text-right font-semibold text-xs uppercase tracking-wider text-slate-600">Share</th>
              <th className="px-4 py-2.5 text-right font-semibold text-xs uppercase tracking-wider text-slate-600">Active publishers</th>
            </tr>
          </thead>
          <tbody>
            {(locales.domains || []).map((d) => (
              <tr key={d.root_domain} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-2.5 font-mono text-xs">{d.root_domain}</td>
                <td className="px-4 py-2.5 text-right font-mono text-sm">{d.clicks.toLocaleString()}</td>
                <td className="px-4 py-2.5 text-right font-mono text-sm">${Number(d.revenue).toFixed(2)}</td>
                <td className="px-4 py-2.5 text-right font-mono text-sm text-slate-500">{d.share_pct}%</td>
                <td className="px-4 py-2.5 text-right font-mono text-sm text-slate-500">{d.publisher_count}</td>
              </tr>
            ))}
            {(locales.domains || []).length === 0 && (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-xs text-slate-400">No locale data in the selected range.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
